module.exports = __webpack_public_path__ + "img/pleisure_bodyimage06.1d630ce6.jpg";